"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTwitterResponse = exports.login = void 0;
const tslib_1 = require("tslib");
let TWTRAuthHandler = null;
function login(getTwitterUrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        if (TWTRAuthHandler)
            throw new Error("Twitter: Login in progress");
        return new Promise((resolve, reject) => {
            TWTRAuthHandler = (response) => resolve(response);
            const open = (w, h) => {
                const left = screen.width / 2 - w / 2, top = screen.height / 2 - h / 2;
                const config = `width=${w}, height=${h}, top=${top}, left=${left}, toolbar=0, location=1, directories=0, status=0, menubar=0, scrollbars=1, resizable=0, copyhistory=0,`;
                return window.open("about:blank", "_blank", config);
            };
            const twWindow = open(400, 600);
            if (!twWindow) {
                throw new Error("Can't open twitter popup");
            }
            const interval = setInterval(() => {
                if (twWindow.closed) {
                    clearInterval(interval);
                    TWTRAuthHandler = null;
                    reject(new Error("Twitter: Closed login popup"));
                }
            }, 1);
            getTwitterUrl().then(src => {
                twWindow.location.href = src;
            });
        });
    });
}
exports.login = login;
function setTwitterResponse(data) {
    if (!TWTRAuthHandler)
        throw new Error("Twitter: Should call login() first");
    TWTRAuthHandler(data);
}
exports.setTwitterResponse = setTwitterResponse;
//# sourceMappingURL=twitter.js.map